import React, { useState, useEffect, useContext } from "react";
import { ENDPOINT } from "../config";
import { AuthenticatedApiContext } from "../../context/AuthenticatedApiContext";
import { href, paths } from "../router";
import "./EntityLinkCard.css";

const BuildingIcon = () => (
  <svg
    style={{ width: "18px", height: "18px", color: "#7c3aed" }}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
    />
  </svg>
);

const ChevronIcon = () => (
  <svg
    className="entity-link-chevron"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M7.5 5l5 5-5 5" />
  </svg>
);

export const EntityLinkCard = ({ title, entities, showCount = false }) => (
  <div className="entity-card">
    <div className="entity-card-head">
      <BuildingIcon />
      <h3>{title}</h3>
      {showCount && (
        <span className="entity-card-count">{entities.length}</span>
      )}
    </div>

    <div className="entity-card-list">
      {entities.map((entity) => (
        <a
          key={entity.id}
          className="entity-link"
          href={href(paths.process(entity.id))}
        >
          <span className="entity-link-name">{entity.company_name}</span>
          <span className="entity-link-meta">
            <span className="entity-link-id">{entity.company_id}</span>
            <ChevronIcon />
          </span>
        </a>
      ))}
    </div>
  </div>
);

export const ChildEntitiesList = ({ processId, refreshKey }) => {
  const [children, setChildren] = useState([]);
  const { get } = useContext(AuthenticatedApiContext);

  useEffect(() => {
    const fetchChildren = async () => {
      try {
        const result = await get(
          `${ENDPOINT}/processes/${processId}/children`,
        );
        setChildren(result);
      } catch (err) {
        console.log("Failed to fetch children", err);
      }
    };
    fetchChildren();
  }, [processId, refreshKey]);

  if (children.length === 0) return null;

  return (
    <EntityLinkCard title="Child Entities" entities={children} showCount />
  );
};

export const ParentEntity = ({ parent }) => {
  if (!parent) return null;

  return <EntityLinkCard title="Parent Entity" entities={[parent]} />;
};
